import { InspectionState } from 'src/api/queries/inspections/useInspectionsOverview';

export interface IInspectionStateMeta {
  state: InspectionState;
  label: string;
  color: string;
}

export const INSPECTION_STATE_META: IInspectionStateMeta[] = [
  { state: InspectionState.Draft, label: 'Draft', color: 'gray' },
  { state: InspectionState.Scheduled, label: 'Scheduled', color: 'blue' },
  { state: InspectionState.InProgress, label: 'In Progress', color: 'yellow' },
  { state: InspectionState.Completed, label: 'Completed', color: 'green' },
];

export const inspectionStateLabel = (state: InspectionState): string =>
  INSPECTION_STATE_META.find((m) => m.state === state)?.label ?? '';

export const inspectionStateColor = (state: InspectionState): string =>
  INSPECTION_STATE_META.find((m) => m.state === state)?.color ?? 'gray';
